import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENTS]: {
		url:'/company/:companyId/done_works/:doneWorkId/documents/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/documents/:documentId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/documents/:documentId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT]: {
		url: '/company/:companyId/done_works/:doneWorkId/documents/:documentId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].CREATE_DONE_WORKS_DOCUMENT]: {
		url:'/company/:companyId/done_works/:doneWorkId/documents/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PATCH_DONE_WORKS_DOCUMENT]: {
		url: '/company/:companyId/done_works/:doneWorkId/documents/:documentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PUT_DONE_WORKS_DOCUMENT]: {
		url: '/company/:companyId/done_works/:doneWorkId/documents/:documentId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].DELETE_DONE_WORKS_DOCUMENT]: {
		url: '/company/:companyId/done_works/:doneWorkId/documents/:documentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}